<template>
    <div slot="label">
        <Tooltip placement="right" transfer v-if="item.tooltip">
            <div slot="content" style="white-space: normal;">
                {{item.tooltip}}
            </div>
            <div style="display: flex;align-items: center;">
                <div v-if="item.required" style="margin-right: 4px;color: red;">*</div>
                {{item.name}}
                <Icon type="ios-help-circle" style="margin-left: 4px;opacity: 0.4;" />
            </div>
        </Tooltip>
        <div v-else>
            <div style="display: flex;align-items: center;">
                <div v-if="item.required" style="margin-right: 4px;color: red;">*</div>
                {{item.name}}
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            item: {
                type: Object,
                default: {}
            },
        },
        data() {
            return {}
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/common/FormItemLabel.vue?4f8f256d